import React from 'react'
import {  Box, Select, MenuItem, TextField} from '@mui/material'
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import borderStyle from '../../styles/borderStyle'
import Time from '../Time';

// const firstRow = {
//     Catagery: "",
//     Job_Descrption: "",
//     Start_Time: "",
//     End_Time: "",
//     id: 1,
//     Bay: "",
//     Status: "",
    
// }
const dataGridStyle = {
  root: {
    "& .MuiDataGrid-root": {
      borderRadius: '10px',
      backgroundColor: 'white',
      fontSize: '14px',
    },
    "& .MuiDataGrid-columnHeaders": {
      // color: '#005A9C',
      fontSize: '18px',
    }
  },
};
// const boxStyle = {
//     root: {
//       backgroundColor: 'white', 
//       borderRadius: '5px',
//       padding: 1
//     },
//   };


function CustomColumnMenu(props) {
    return (
      
      <GridColumnMenu
        {...props}
        slots={{
       // Hide `columnMenuColumnsItem`
        columnMenuColumnsItem: null,
        columnMenuSortItem: null,
        }}
      />
      
  );
  }
       



function JobTask() {
    
    const columns = [
    { field: 'id', headerName: ' NO', editable: false, sortable: false },
    { field: 'Category', headerName: 'Category', editable: false, sortable: false },
    { field: 'Job_Descrption', headerName: 'Job Descrption', editable: false, sortable: false, flex: 2, minWidth: 100 },
    { field: 'Start_Time', headerName: 'Start Time', editable: false, sortable: false, flex: 1 , minWidth: 100,
    renderCell: (params) => (
      <Time />
      )},
    { field: 'End_Time', headerName: 'End Time', editable: false, sortable: false, flex: 1, minWidth: 100, renderCell: (params) => (
      <Time/>
      )}, 
    { field: 'Bay', headerName: 'Bay', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Status', headerName: 'Status', editable: false, sortable: false, flex: 1 , minWidth: 100,
    renderCell: (params) => (
      <Select
          fullWidth
          variant="outlined"
          style={borderStyle.root}
          // value={params.row.Status}
          // onChange={(e) => handleFieldChange(e, params.row.id, 'discType')}
          size="small"
      >
          <MenuItem value="1" > In Progress </MenuItem>
          <MenuItem value="2" > Completed </MenuItem>
          <MenuItem value="3" > Rejected </MenuItem>
      </Select>
  )},
  
  ]; 
  
    
    const rows = [
    { id: '1', Category: 'Engine', Job_Descrption: 'Engin Oil Filter Replacement Done', Start_Time: '', End_Time:'', Bay:'MOT Bay', Status:''},
    { id: '2', Category: 'Engine', Job_Descrption: 'Engin Oil Top Up Done', Start_Time: '', End_Time:'', Bay:'MOT Bay', Status:''  },
    { id: '3', Category: 'Engine', Job_Descrption: 'Speedometer Cable Replacement', Start_Time: '', End_Time:'', Bay:'MOT Bay', Status:''  },
    
    ]; 

    return (
      <form>
        <Box sx={dataGridStyle.root}>
          <DataGrid
            columnHeaderHeight={30}
            rowHeight={30}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
            pageSizeOptions={[10]}
            slots={{ columnMenu: CustomColumnMenu }}
            disableRowSelectionOnClick
          />
        </Box>
      </form>
    );
}

export default JobTask